export enum OtherChildTab {
  Template = 'settings/other/template',
}

export const OtherTabList = [
  {
    id: OtherChildTab.Template,
    title: 'Quản lý biểu mẫu',
  },
  // {
  //   id: OtherChildTab.Enterprise,
  //   title: 'Doanh nghiệp'
  // },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/other/other.const.ts